<template>
	<router-link :to="{ name: 'AlertList', params: { user_uid: user_uid } }" class="see-all" :class="{ 'no-alert': alerts_length == 0 }">
		<div class="body" :class="{ 'no-alert': alerts_length == 0 }">
			<svgicon v-if="alerts_length" name="alert" :fill="false"/>
			<svgicon v-else name="no alert" :fill="false"/>
			<span v-if="alerts_length">{{ $t('base.general.see_all_alerts') }}</span>
			<span v-else>{{ $t('base.general.no_alerts') }}</span>
			<div v-if="alerts_length" class="alerts-number">{{ alerts_length }}</div>
		</div>
	</router-link>
</template>

<script>
export default {
	props: [
		'user_uid',
		'alerts_length'
	]
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/components/SeeAllAlerts.vue